module.exports = __webpack_public_path__ + "static/media/IC_perfom_measuring.96f42ae0.svg";